// extracted by mini-css-extract-plugin
export default {"tr":"MicropileCapacityTable_tr__3gCBH","tdLeft":"MicropileCapacityTable_tdLeft__mYliw","info":"MicropileCapacityTable_info__n63jM","tbody":"MicropileCapacityTable_tbody__tUqYN"};